<template>
	<div class="user">
		<!-- <div>
			<a class="notification-action color-darkblue padding-5  text-white"
				href="https://uphellas.atlassian.net/servicedesk/customer/portal/15" target="_blank">
				{{ $t("needHelpButton") }}
			</a>
		</div> -->

		<div class="openNotifications cursor-pointer" v-click-outside="hideNotification" @click="openNotifications">
			<div>
				<font-awesome-icon icon="university" size="2x" />

				<span v-if="selectedCompany.company_id > 0">{{ " " + selectedCompany.company_id + " - "  + selectedCompany.name.trim()  + " (" + selectedCompanyVAT + ")" }}</span>
			</div>
			<div class="notification-box" v-show="isOpenNotification">
				<div class="main-notification">
					<table cellpadding="10" cellspacing="0" width="100%" style="text-align: left" align="center"
						class="hover-table">
						<tr v-for="company in this.user.companies" :key="company.company_id"
							@click="selectCompany(company.company_id)" class="trhover" :class="selectedCompany.company_id === company.company_id && 'gri-cell'
								">
							<td class="notification-footer">
								<p>
									<font-awesome-icon icon="university" />

									{{ company.name }}
								</p>
							</td>
							<td class="notification-footer" style="text-align: right">
								<p>{{ company.company_id }}</p>
							</td>
						</tr>
					</table>
				</div>
			</div>
		</div>

		<div>
			<img src="@/assets/images/linie.png" />
		</div>
		<div class="openUserMenu" v-click-outside="hide" @click="openUserMenu">
			<img src="@/assets/images/settings.png" />
			<!-- <a href="#">{{ this.user.first_name | titleCase }}</a> -->
			<img src="@/assets/images/arrow-down.svg" />
			<div class="userMenu" v-show="isOpen">
				<a href="/customer/account" class="account" :class="this.menuSelected.account && 'account-active'">{{
					$t("settingsName") }}</a>
				<a href="#" class="logout" @click="logout()">{{ $t("logoutName") }}</a>
			</div>
		</div>
		<LanguageBar />
	</div>
</template>
<script>
import httpServiceCustomer from "@/http/http-customer.js";
import ClickOutside from "vue-click-outside";
import LanguageBar from "@/components/LanguageBar.vue";
import utils from "@/plugins/utils.js";

export default {
	name: "TopBar",
	props: {
		user: null,
	},
	components: {
		LanguageBar,
	},
	directives: {
		ClickOutside,
	},
	data() {
		return {
			customerMessages: null,
			menuSelected: {
				faq: false,
				account: false,
			},
			config: JSON.parse(localStorage.getItem("jsonFile")),
			readMessagesCount: 0,
			isOpenNotification: false,
			isOpen: false,
			selectedCompany: null,
		};
	},
	methods: {
		openUserMenu() {
			this.isOpen = !this.isOpen;
		},
		openNotifications() {
			this.isOpenNotification = !this.isOpenNotification;
		},
		isReadNotification(message) {
			message.read = true;
			httpServiceCustomer.customerService
				.markMessageAsRead(message, this.token)
				.catch(function () {
					// handle error
				});
		},
		selectCompany(id) {
			// localStorage.removeItem("selectedCompany");
			sessionStorage.removeItem("customer_data");
			
			sessionStorage.setItem(
				"selectedCompany",
				JSON.stringify({
					company_id: id,
					role: "CST",
				},)
			);
			this.$router.go();
		},
		hide() {
			this.isOpen = false;
		},
		hideNotification() {
			this.isOpenNotification = false;
		},
		logout() {
			utils.logout();
		},
		goBack() {
			window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
		},
	},
	computed: {
		// selectedCompanyName() {
		// 	// if ()
		// 	for (let index in this.user.companies) {
		// 		let company = this.user.companies[index];
		// 		if (this.selectedCompany.company_id === company.company_id) {
		// 			return company.name;
		// 		}
		// 	}
		// 	return "";
		// },
		selectedCompanyVAT() {
			// if ()
			return this.selectedCompany.VAT;
		},
	},
	created() {
		switch (this.$route.name) {
			case "customer_faq":
				this.menuSelected.faq = true;
				break;
			case "customer_account":
				this.menuSelected.account = true;
				break;
		}
		this.selectedCompany = JSON.parse(sessionStorage.getItem("customer_data"));
		if (!this.selectedCompany) {
			this.selectedCompany = this.user.companies[0];
		}
	},
};
</script>
<style scoped src="@/assets/styles/beneficiary.css"></style>
